import { gql } from "@apollo/client";
export const verification = gql`
  fragment verification on Verification {
    documentVerificationId
    verificationName
    statusName
    statusCode
    message
    verificationDate
    userName
    validityDate
    entityName
    summaryTitle
    summary
    verificationTypeIsActive
  }
`;
